module.exports = __webpack_public_path__ + "img/kanji-search-Tashii-Designs.e9da9747.png";